import { render } from "./CostiRicaviPreventivoSottoProgetto.vue?vue&type=template&id=300801da&scoped=true&ts=true"
import script from "./CostiRicaviPreventivoSottoProgetto.vue?vue&type=script&lang=ts"
export * from "./CostiRicaviPreventivoSottoProgetto.vue?vue&type=script&lang=ts"

import "./CostiRicaviPreventivoSottoProgetto.vue?vue&type=style&index=0&id=300801da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-300801da"]])

export default __exports__